import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/9861699c-84a1-47cb-99a1-a59de1c49b16/workspace/streffy-middle-office_pMRG/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
/*
 * @Description: 三方免登录
 * @Author: rhd
 * @Date: 2024-10-15 14:10:17
 * @LastEditors: rhd
 * @LastEditTime: 2025-03-07 17:55:24
 */
import { GetUserInfo } from '@api/account';
import { replace } from 'lodash';
import util from '@/libs/util';
import dayjs from "dayjs";
import store from '@/store/index';
var utilThree = {};
// 查询三方登录ticket详情数据
utilThree.getTicketUser = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(urlParams, toRouteUrl, router) {
    var ticket, treeToken, paramsData;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          ticket = decodeURIComponent(urlParams.t);
          console.log('【三方登录 created】url 携带的 ticket', ticket);
          window.localStorage.setItem('treeToken', ticket);
          treeToken = window.localStorage.getItem('treeToken');
          store.state.admin.user.treeToken = treeToken;
          console.log('【三方登录 created】localStorage 缓存的 ticket', treeToken);
          util.cookies.set('token', ticket, {}, true);
          console.log('查询三方登录ticket详情数据 ticket', ticket);
          // 开始请求接口
          paramsData = {
            byTicket: 1
          };
          _context2.next = 11;
          return GetUserInfo(paramsData).then(/*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(result) {
              var header, item, extra, nowDateTime, _result;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    header = result.header, item = result.item;
                    if (!(header && header.code === 200 && item)) {
                      _context.next = 8;
                      break;
                    }
                    if (item.roles && item.roles.length) {
                      item.roles.map(function (element) {
                        return {
                          RoleId: element.roleId,
                          RoleName: element.roleName,
                          RoleType: element.roleType
                        };
                      });
                    }
                    extra = {
                      Name: item.name,
                      Roles: item.roles || [],
                      Stores: item.stores || [],
                      TenantId: item.tenantId,
                      TenantName: item.tenantName,
                      UserId: item.managerId
                    };
                    nowDateTime = urlParams.n ? dayjs(replace(urlParams.n, 'T', ' ')).format('YYYY-MM-DD HH:mm:ss') : dayjs().format('YYYY-MM-DD HH:mm:ss');
                    _result = {
                      expire: 7200,
                      extra: extra,
                      now: nowDateTime,
                      ticket: ticket
                    };
                    _context.next = 8;
                    return store.dispatch('admin/account/setInitUserTicket', _result).then(function () {
                      // setTimeout(() => {
                      //     // 重定向对象不存在则返回顶层路径
                      //     console.log('toRouteUrl', toRouteUrl)
                      //     router.replace(toRouteUrl);
                      // }, 1000);
                    }).catch(function () {
                      // this.$loading.hide()
                    });
                  case 8:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x4) {
              return _ref2.apply(this, arguments);
            };
          }()).catch(function (error) {
            console.log('查询三方登录ticket详情数据 error', error);
          });
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export default utilThree;